/**
 * 造价师认证「所在地区」多选项（展示名称与接口 region 逗号拼接一致，与导航栏地区名称对齐）。
 * 有省下辖市的省份在 UI 中展开为具体城市；提交 region 为城市名或直辖市等叶子名称，逗号分隔。
 */
import { getCitiesForProvince, provinceNeedsCityPicker } from './provinceCities'

export const CERT_REGION_CATEGORIES = [
  { name: '不限', regions: ['全国'] },
  {
    name: '华北',
    regions: ['北京', '天津', '河北省', '山西省', '内蒙古']
  },
  {
    name: '东北',
    regions: ['辽宁省', '吉林省', '黑龙江省']
  },
  {
    name: '华东',
    regions: ['上海', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省']
  },
  {
    name: '华中',
    regions: ['湖北省', '湖南省', '河南省']
  },
  {
    name: '华南',
    regions: ['广东省', '广西', '海南省']
  },
  {
    name: '西南',
    regions: ['重庆', '四川省', '贵州省', '云南省', '西藏']
  },
  {
    name: '西北',
    regions: ['陕西省', '甘肃省', '青海省', '宁夏', '新疆']
  },
  {
    name: '其他',
    regions: ['香港特别行政区', '澳门特别行政区', '台湾省']
  },
  {
    name: '海外',
    regions: ['亚洲', '欧洲', '美洲', '非洲', '澳洲']
  }
]

/** 所有可选「叶子」名称：省展开为市，其余为自身（全国、直辖市、港澳台、海外等） */
export function getAllCertLeafRegionLabels() {
  const set = new Set()
  CERT_REGION_CATEGORIES.forEach(cat => {
    cat.regions.forEach(r => {
      if (provinceNeedsCityPicker(r)) {
        const cities = getCitiesForProvince(r) || []
        cities.forEach(c => set.add(c))
      } else {
        set.add(r)
      }
    })
  })
  return Array.from(set)
}

/** @deprecated 使用 getAllCertLeafRegionLabels */
export function getAllCertRegionLabels() {
  return getAllCertLeafRegionLabels()
}
